import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

/**
 * The four CAM headline KPIs: total parameters, passed, failed, and an overall
 * risk level with a pass-rate bar.
 */
const CamSummaryCards = ({ summary }) => {
    const s = summary || {};
    return (
        <div className={"cc-cam-kpis"}>
            <div className={"cc-cam-kpi cc-cam-kpi--info"}>
                <div className={"cc-cam-kpi__body"}>
                    <span className={"cc-cam-kpi__label"}>Total Parameters</span>
                    <span className={"cc-cam-kpi__value"}>{s.total || 0}</span>
                    <span className={"cc-cam-kpi__sub"}>Across all categories</span>
                </div>
                <span className={"cc-cam-kpi__icon"}>
                    <Icon type={"bar-chart"} />
                </span>
            </div>

            <div className={"cc-cam-kpi cc-cam-kpi--good"}>
                <div className={"cc-cam-kpi__body"}>
                    <span className={"cc-cam-kpi__label"}>Passed Checks</span>
                    <span className={"cc-cam-kpi__value"}>{s.pass || 0}</span>
                    <span className={"cc-cam-kpi__sub"}>Met criteria</span>
                </div>
                <span className={"cc-cam-kpi__icon"}>
                    <Icon type={"check-circle"} />
                </span>
            </div>

            <div className={"cc-cam-kpi cc-cam-kpi--bad"}>
                <div className={"cc-cam-kpi__body"}>
                    <span className={"cc-cam-kpi__label"}>Failed Checks</span>
                    <span className={"cc-cam-kpi__value"}>{s.fail || 0}</span>
                    <span className={"cc-cam-kpi__sub"}>Require attention</span>
                </div>
                <span className={"cc-cam-kpi__icon"}>
                    <Icon type={"exclamation-circle"} />
                </span>
            </div>

            <div
                className={
                    "cc-cam-kpi cc-cam-kpi--risk cc-cam-kpi--" +
                    (s.riskTone || "warn")
                }
            >
                <div className={"cc-cam-kpi__body"}>
                    <span className={"cc-cam-kpi__label"}>Risk Level</span>
                    <span className={"cc-cam-kpi__value"}>
                        {s.riskLabel || "—"}
                    </span>
                    <div className={"cc-cam-risk"}>
                        <div className={"cc-cam-risk__track"}>
                            <div
                                className={"cc-cam-risk__fill"}
                                style={{ width: `${s.passPct || 0}%` }}
                            />
                        </div>
                        <span className={"cc-cam-risk__pct"}>
                            {s.passPct || 0}%
                        </span>
                    </div>
                    <span className={"cc-cam-kpi__sub"}>
                        Overall pass rate across categories
                    </span>
                </div>
            </div>
        </div>
    );
};

CamSummaryCards.propTypes = {
    summary: PropTypes.object
};

export default CamSummaryCards;
